import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

export default function PopularDestinations({ limit }) {
    const [destinations, setDestinations] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchDestinations = async () => {
            try {
                const res = await axios.get("https://dubaicheaphotels.com/api/destinations");
                setDestinations(res.data);
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchDestinations();
    }, []);

    return (
        <section className="py-10 sm:py-12 md:py-16 lg:py-20 bg-gradient-to-b from-white to-orange-50/30">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                {/* Header */}
                <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12">

                    <div>
                        <span className="inline-flex items-center px-4 py-2 rounded-full bg-orange-50 text-[#FF6B35] text-sm font-semibold mb-4">
                            Popular Places
                        </span>

                        <h2 className="text-3xl md:text-4xl font-bold text-slate-900">
                            Explore Dubai's Top Destinations
                        </h2>

                        <p className="text-slate-500 mt-3 max-w-2xl">
                            Discover the most popular areas, landmarks and tourist
                            hotspots across Dubai with the best hotel deals.
                        </p>
                    </div>

                    <button
                        onClick={() => navigate("/destinations")}
                        className="hidden sm:flex items-center gap-2 px-6 py-3 bg-[#FF6B35] text-white rounded-xl hover:bg-orange-600 transition"
                    >
                        View All Destinations
                        →
                    </button>

                </div>

                {/* Loading */}
                {loading ? (
                    <div className="flex justify-center py-10">
                        <div className="animate-spin h-10 w-10 border-4 border-teal-500 border-t-transparent rounded-full"></div>
                    </div>
                ) : (
                    <>
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                            {destinations.slice(0, limit).map((dest) => (
                                <div
                                    key={dest.id}
                                    onClick={() =>
                                        navigate(`/destinations/${dest.slug}`)
                                    }
                                    className="group relative h-[380px] rounded-[28px] overflow-hidden cursor-pointer"
                                >
                                    {/* Image */}
                                    <img
                                        src={`https://dubaicheaphotels.com/uploads/destinations/${dest.image}`}
                                        alt={dest.name}
                                        className="w-full h-full object-cover group-hover:scale-110 transition duration-700"
                                    />

                                    {/* Overlay */}
                                    <div className="absolute inset-0 bg-gradient-to-t from-black via-black/20 to-transparent"></div>

                                    {/* Content */}
                                    <div className="absolute bottom-5 left-5 right-5">

                                        <div className="backdrop-blur-md bg-white/15 border border-white/20 rounded-2xl p-4">

                                            <div className="flex items-center justify-between">

                                                <div>
                                                    <h3 className="text-xl font-bold text-white">
                                                        {dest.name}
                                                    </h3>

                                                    <p className="text-white/80 text-sm mt-1">
                                                        {dest.hotels_count} Hotels Available
                                                    </p>
                                                </div>

                                                <div className="w-10 h-10 rounded-full bg-white text-[#FF6B35] flex items-center justify-center transform translate-x-4 opacity-0 group-hover:translate-x-0 group-hover:opacity-100 transition duration-300">
                                                    →
                                                </div>

                                            </div>

                                        </div>

                                    </div>

                                </div>
                            ))}
                        </div>

                        {/* Mobile Button */}
                        <div className="mt-8 sm:hidden">
                            <button
                                onClick={() => navigate("/destinations")}
                                className="w-full bg-[#FF6B35] text-white px-5 py-3 rounded-xl"
                            >
                                View All Destinations
                            </button>
                        </div>
                    </>
                )}
            </div>
        </section>
    );
}